(() => {
  const config = document.querySelector('#nized-optional-integrations');
  if (!config) return;
  let integrations;
  try { integrations = JSON.parse(config.textContent); } catch { return; }
  const loaded = new Set();
  const sync = () => {
    integrations.forEach(integration => {
      if (loaded.has(integration.id) || !window.NizedConsent?.allowed(integration.category)) return;
      loaded.add(integration.id);
      if (Array.from(document.scripts).some(script => script.src === integration.src)) return;
      const script = document.createElement('script');
      script.async = true;
      script.src = integration.src;
      script.dataset.nizedIntegration = integration.id;
      document.head.appendChild(script);
    });
  };
  window.addEventListener('nized:consent', sync);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync, {once: true});
  else sync();
})();
